<template>
    <div>
        <div>title</div>
        <div>
            <button @click="clickLink()" class="btn-green">Go Line</button>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi'

export default {
    name: 'MaintenanceStore',
    data: function() {
        return {
            urlLine: null,
        };
    },
    created: function() {
        this.getConfig();
    },
    methods: {
        getConfig: function() {
            let url = Vue.bzbsConfig.bzbsBlobUrl + '/config/chanel/announce.json';
            BzbsApi.connectBzbsBlob(url).then((res) => {
                console.log(res.data);
                this.urlLine = res.data.link;
            }).catch((err) => {
                console.log(err);
            });
        },

        clickLink: function() {
            window.location.replace(this.urlLine);
        },
    },
}
</script>
<style lang="scss" scoped>
    .btn-green {
        background: green;
        color: #fff;
    }
</style>
